import {Component} from "@angular/core";

import {AppController} from "../AppController";

@Component({
  selector: "app-user-error-page",
  templateUrl: "./UserErrorPage.html",
})
export class UserErrorPage {

  public constructor(private readonly _appController: AppController) {}

  public get appController() {
    return this._appController;
  }

  public get errorMessage() {
    return this._appController.latestErrorMessage;
  }

}
